import { useQuery } from '@tanstack/react-query';
import { settingsService } from '@/services';
import { queryKeys } from '@/services/query-keys';
import type { InstrumentMapping } from '@/services/settings/settings-service';

export function useInstrumentMappings(counterparty: string, enabled = true) {
  return useQuery<InstrumentMapping>({
    queryKey: queryKeys.settings.instrumentMappings(counterparty),
    queryFn: () => settingsService.getInstrumentMappings(counterparty),
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    enabled,
  });
}

export function getCounterpartyProductId(
  mapping: InstrumentMapping | undefined,
  symbolId: string,
): string {
  return mapping?.[symbolId] ?? symbolId.split('.')[0];
}
